const en = {
  'cancelledServices.meaning.serviceDate':
    'Scheduled start, otherwise trip creation time. Not the cancellation filter date.',
  'cancelledServices.meaning.finalTotal': 'Cancelled trips have no settlement final total.',
  'cancelledServices.meaning.adjustment':
    'Persisted current fare minus immutable quoted fare; null when either is missing. No repricing.',
  'cancelledServices.meaning.received':
    'Recorded BASE/OVERAGE receipts including refunded receipts. Not net cash or agent payout.',
  'cancelledServices.meaning.review':
    'Missing fare with payments requires review. With fare, non-free cancelled receipts require review unless all received payments are refunded.',
  'cancelledServices.value.CANCELLED': 'Cancelled',
  'cancelledServices.value.OUTBOUND': 'Outbound',
  'cancelledServices.value.RETURN': 'Return',
  'cancelledServices.value.AUTO': 'Automatic',
  'cancelledServices.value.MANUAL': 'Manual',
  'cancelledServices.value.SCHEDULED_START': 'Scheduled start',
  'cancelledServices.value.CREATED_AT_FALLBACK': 'Creation time fallback',
  'cancelledServices.value.CANCELLATION_EVENT': 'Cancellation event',
  'cancelledServices.value.UNAVAILABLE': 'Unavailable',
  'cancelledServices.value.CURRENT_REASON': 'Current reason master',
  'cancelledServices.value.CURRENT_SERVICE_GROUP': 'Current service group',
  'cancelledServices.value.NONE': 'No fare',
  'cancelledServices.value.PROVISIONAL': 'Provisional',
  'cancelledServices.value.FINAL': 'Final',
  'cancelledServices.value.CANCELLED_SNAPSHOT': 'Cancelled fare snapshot',
  'cancelledServices.value.BOOKING_SNAPSHOT': 'Booking snapshot',
  'cancelledServices.value.STATUS_EVENTS': 'Status events',
  'cancelledServices.value.GPS_TRACE': 'GPS trace',
  'cancelledServices.value.UNKNOWN': 'Unknown',
  'cancelledServices.value.PLANNED_FALLBACK': 'Planned fallback',
  'cancelledServices.value.PENDING_SLIP': 'Awaiting slip',
  'cancelledServices.value.SLIP_SUBMITTED': 'Slip submitted',
  'cancelledServices.value.VERIFIED': 'Verified',
  'cancelledServices.value.REJECTED': 'Rejected',
  'cancelledServices.value.WAIVED': 'Waived',
  'cancelledServices.value.REFUND_PENDING': 'Refund pending',
  'cancelledServices.value.REFUNDED': 'Refunded',
  'cancelledServices.value.THB': 'Thai baht',
  'cancelledServices.title': 'Cancelled services',
  'cancelledServices.description':
    'One row per currently cancelled trip. Actor names are event snapshots; assigned people, scope and reason labels are current. Receipts are retained, not net cash after refunds.',
  'cancelledServices.dateBasis': 'Latest cancellation event; all-time includes undated trips',
  'cancelledServices.empty': 'Unavailable or not applicable; zero is an observed numeric value.',
  'cancelledServices.source.actorSnapshot':
    'Immutable actor name recorded on the selected cancellation event; photo resolves current actor type and ID.',
  'cancelledServices.source.reason': 'Current reasons table label, not a historical label.',
  'cancelledServices.source.event':
    'Latest TRIP CANCELLED event by time then ID; supported string meta only; no timestamp fallback.',
  'cancelledServices.source.finance':
    'Canonical persisted fare and BASE/OVERAGE payment facts; terminal billed and outstanding totals are zero, receipts retained without repricing.',
  'cancelledServices.source.currentScope': 'Current service-group area mappings, not historical coverage.',
  'cancelledServices.source.currentTrip':
    'Persisted trip and booking fields with current passenger, assigned agent, vehicle and master labels. Agent code is unavailable without a persisted code.',
  'cancelledServices.column.provider_id': 'Provider ID',
  'cancelledServices.column.provider_name': 'Provider',
  'cancelledServices.column.trip_id': 'Trip ID',
  'cancelledServices.column.trip_ref': 'Trip reference',
  'cancelledServices.column.booking_id': 'Booking ID',
  'cancelledServices.column.trip_status': 'Trip status',
  'cancelledServices.column.trip_leg': 'Trip leg',
  'cancelledServices.column.service_mode': 'Service mode',
  'cancelledServices.column.dispatch_mode': 'Dispatch mode',
  'cancelledServices.column.created_at': 'Created at',
  'cancelledServices.column.service_date': 'Service date',
  'cancelledServices.column.service_date_basis': 'Service date basis',
  'cancelledServices.column.scheduled_start': 'Scheduled start',
  'cancelledServices.column.scheduled_end': 'Scheduled end',
  'cancelledServices.column.pickup_appt_at': 'Pickup appointment',
  'cancelledServices.column.arrive_by_at': 'Arrive by',
  'cancelledServices.column.cancel_event_id': 'Cancellation event ID',
  'cancelledServices.column.cancelled_at': 'Cancelled at',
  'cancelledServices.column.date_basis': 'Cancellation date basis',
  'cancelledServices.column.cancel_actor_type': 'Cancellation actor type',
  'cancelledServices.column.cancel_actor_id': 'Cancellation actor ID',
  'cancelledServices.column.cancel_actor_name': 'Cancellation actor (snapshot)',
  'cancelledServices.column.cancel_reason_id': 'Reason ID',
  'cancelledServices.column.cancel_reason_code': 'Reason code',
  'cancelledServices.column.cancel_reason_label': 'Reason (current)',
  'cancelledServices.column.cancel_reason_label_source': 'Reason label source',
  'cancelledServices.column.cancel_note': 'Cancellation note',
  'cancelledServices.column.passenger_reason': 'Passenger reason',
  'cancelledServices.column.passenger_id': 'Passenger ID',
  'cancelledServices.column.passenger_code': 'Passenger code',
  'cancelledServices.column.passenger_name': 'Passenger (current)',
  'cancelledServices.column.passenger_phone': 'Passenger phone',
  'cancelledServices.column.agent_id': 'Assigned agent ID',
  'cancelledServices.column.agent_code': 'Agent code',
  'cancelledServices.column.agent_name': 'Assigned agent (current)',
  'cancelledServices.column.agent_phone': 'Agent phone',
  'cancelledServices.column.vehicle_id': 'Vehicle ID',
  'cancelledServices.column.vehicle_plate': 'Vehicle plate',
  'cancelledServices.column.service_area_ids': 'Current service area IDs',
  'cancelledServices.column.service_area_names': 'Current service areas',
  'cancelledServices.column.service_group_id': 'Service group ID',
  'cancelledServices.column.service_group_name': 'Service group',
  'cancelledServices.column.scope_provenance': 'Scope provenance',
  'cancelledServices.column.origin_label': 'Origin',
  'cancelledServices.column.destination_label': 'Destination',
  'cancelledServices.column.currency': 'Currency',
  'cancelledServices.column.fare_state': 'Fare state',
  'cancelledServices.column.quote_provenance': 'Quote provenance',
  'cancelledServices.column.quoted_total': 'Quoted total',
  'cancelledServices.column.current_total': 'Current persisted fare',
  'cancelledServices.column.final_total': 'Final total',
  'cancelledServices.column.fare_adjustment_delta': 'Fare adjustment',
  'cancelledServices.column.fare_base': 'Base fare',
  'cancelledServices.column.fare_overage_distance': 'Distance overage fare',
  'cancelledServices.column.fare_overage_time': 'Time overage fare',
  'cancelledServices.column.fare_surcharge_total': 'Surcharges',
  'cancelledServices.column.fare_computed_at': 'Fare computed at',
  'cancelledServices.column.billing_distance_source': 'Billing distance source',
  'cancelledServices.column.billing_duration_source': 'Billing duration source',
  'cancelledServices.column.billable_distance_km': 'Billable distance (km)',
  'cancelledServices.column.billable_duration_min': 'Billable duration (min)',
  'cancelledServices.column.fare_is_free': 'Free entitlement',
  'cancelledServices.column.base_payment_status': 'Base payment status',
  'cancelledServices.column.base_amount_due': 'Base amount due',
  'cancelledServices.column.base_amount_received': 'Base receipts',
  'cancelledServices.column.base_outstanding': 'Base outstanding',
  'cancelledServices.column.base_due_by': 'Base due by',
  'cancelledServices.column.base_verified_at': 'Base verified at',
  'cancelledServices.column.overage_payment_status': 'Overage payment status',
  'cancelledServices.column.overage_amount_due': 'Overage amount due',
  'cancelledServices.column.overage_amount_received': 'Overage receipts',
  'cancelledServices.column.overage_outstanding': 'Overage outstanding',
  'cancelledServices.column.overage_due_by': 'Overage due by',
  'cancelledServices.column.overage_verified_at': 'Overage verified at',
  'cancelledServices.column.billed_total': 'Billed total',
  'cancelledServices.column.received_total': 'Receipts total',
  'cancelledServices.column.outstanding_total': 'Outstanding total',
  'cancelledServices.column.payment_state': 'Payment state',
  'cancelledServices.column.requires_finance_review': 'Requires finance review',
  'cancelledServices.summary.cancelledTripCount': 'Cancelled trips',
  'cancelledServices.summary.fareTotalSum': 'Persisted fare total',
  'cancelledServices.summary.billedTotalSum': 'Billed total',
  'cancelledServices.summary.receivedTotalSum': 'Receipts total',
  'cancelledServices.summary.outstandingTotalSum': 'Outstanding total',
  'cancelledServices.summary.freeTripCount': 'Free payment trips',
  'cancelledServices.summary.financeReviewCount': 'Finance review trips',
  'cancelledServices.summary.missingFareCount': 'Missing fare trips',
  'cancelledServices.coverage.missingEventCount':
    'Matching cancellations without event time (excluded from finite date ranges)',
  'cancelledServices.summary.passengerActorCount': 'Passenger cancellations',
  'cancelledServices.summary.agentActorCount': 'Agent cancellations',
  'cancelledServices.summary.orgUserActorCount': 'Operator cancellations',
  'cancelledServices.summary.partnerActorCount': 'Partner cancellations',
  'cancelledServices.summary.systemActorCount': 'System cancellations',
  'cancelledServices.summary.unknownActorCount': 'Unknown actors',
  'cancelledServices.filter.actorType': 'Cancellation actor type',
  'cancelledServices.filter.reasonId': 'Reason ID',
  'cancelledServices.filter.reasonCode': 'Reason code',
  'cancelledServices.filter.paymentState': 'Payment state',
  'cancelledServices.filter.requiresFinanceReview': 'Requires finance review',
  'cancelledServices.filter.hasEvent': 'Has cancellation event',
  'cancelledServices.filter.serviceMode': 'Service mode',
  'cancelledServices.filter.passengerId': 'Passenger ID',
  'cancelledServices.filter.agentId': 'Assigned agent ID',
  'cancelledServices.option.actorType.PASSENGER': 'Passenger',
  'cancelledServices.option.actorType.AGENT': 'Agent',
  'cancelledServices.option.actorType.ORG_USER': 'Operator',
  'cancelledServices.option.actorType.PARTNER': 'Partner',
  'cancelledServices.option.actorType.SYSTEM': 'System',
  'cancelledServices.option.actorType.UNKNOWN': 'Unknown',
  'cancelledServices.option.paymentState.FREE': 'Free',
  'cancelledServices.option.paymentState.FINANCE_REVIEW': 'Finance review',
  'cancelledServices.option.paymentState.NOT_BILLABLE': 'Not billable',
  'cancelledServices.option.paymentState.UNBILLED': 'Unbilled',
  'cancelledServices.option.paymentState.OUTSTANDING': 'Outstanding',
  'cancelledServices.option.paymentState.PARTIAL': 'Partial',
  'cancelledServices.option.paymentState.SETTLED': 'Settled',
  'cancelledServices.option.serviceMode.RIDE_AND_CARE': 'Ride and care',
  'cancelledServices.option.serviceMode.CARE': 'Care',
  'cancelledServices.option.serviceMode.RIDE': 'Ride',
  'cancelledServices.option.serviceMode.TRAVEL': 'Travel',
} as const;
const th: Record<keyof typeof en, string> = {
  'cancelledServices.meaning.serviceDate': 'เวลาเริ่มตามนัด หากไม่มีใช้เวลาสร้างเที่ยว ไม่ใช่วันที่ใช้กรองการยกเลิก',
  'cancelledServices.meaning.finalTotal': 'เที่ยวยกเลิกไม่มียอดราคาสุดท้ายจากการชำระ',
  'cancelledServices.meaning.adjustment': 'ค่าโดยสารปัจจุบันที่บันทึกลบราคาเสนอเดิม ว่างเมื่อขาดข้อมูลฝ่ายใด ไม่คำนวณราคาใหม่',
  'cancelledServices.meaning.received': 'ยอดรับ BASE/OVERAGE ที่บันทึก รวมยอดคืนแล้ว ไม่ใช่เงินสดสุทธิหรือค่าจ้างผู้ดูแล',
  'cancelledServices.meaning.review':
    'ขาดค่าโดยสารแต่มีรายการชำระต้องตรวจสอบ เมื่อมีค่าโดยสาร เที่ยวไม่ฟรีที่ยกเลิกและมียอดรับต้องตรวจสอบ เว้นแต่รายการที่รับเงินทั้งหมดคืนแล้ว',
  'cancelledServices.value.CANCELLED': 'ยกเลิก',
  'cancelledServices.value.OUTBOUND': 'ขาไป',
  'cancelledServices.value.RETURN': 'ขากลับ',
  'cancelledServices.value.AUTO': 'อัตโนมัติ',
  'cancelledServices.value.MANUAL': 'จัดสรรด้วยมือ',
  'cancelledServices.value.SCHEDULED_START': 'เวลาเริ่มตามนัด',
  'cancelledServices.value.CREATED_AT_FALLBACK': 'ใช้เวลาสร้างแทน',
  'cancelledServices.value.CANCELLATION_EVENT': 'เหตุการณ์ยกเลิก',
  'cancelledServices.value.UNAVAILABLE': 'ไม่ทราบ',
  'cancelledServices.value.CURRENT_REASON': 'เหตุผลหลักปัจจุบัน',
  'cancelledServices.value.CURRENT_SERVICE_GROUP': 'กลุ่มบริการปัจจุบัน',
  'cancelledServices.value.NONE': 'ไม่มีค่าโดยสาร',
  'cancelledServices.value.PROVISIONAL': 'เบื้องต้น',
  'cancelledServices.value.FINAL': 'สุดท้าย',
  'cancelledServices.value.CANCELLED_SNAPSHOT': 'ค่าโดยสารที่บันทึกก่อนยกเลิก',
  'cancelledServices.value.BOOKING_SNAPSHOT': 'ข้อมูลขณะจอง',
  'cancelledServices.value.STATUS_EVENTS': 'เหตุการณ์สถานะ',
  'cancelledServices.value.GPS_TRACE': 'ข้อมูล GPS',
  'cancelledServices.value.UNKNOWN': 'ไม่ทราบ',
  'cancelledServices.value.PLANNED_FALLBACK': 'ใช้แผนแทน',
  'cancelledServices.value.PENDING_SLIP': 'รอหลักฐานชำระ',
  'cancelledServices.value.SLIP_SUBMITTED': 'ส่งหลักฐานแล้ว',
  'cancelledServices.value.VERIFIED': 'ตรวจสอบแล้ว',
  'cancelledServices.value.REJECTED': 'ปฏิเสธ',
  'cancelledServices.value.WAIVED': 'ยกเว้น',
  'cancelledServices.value.REFUND_PENDING': 'รอคืนเงิน',
  'cancelledServices.value.REFUNDED': 'คืนเงินแล้ว',
  'cancelledServices.value.THB': 'บาทไทย',
  'cancelledServices.title': 'บริการที่ยกเลิก',
  'cancelledServices.description':
    'หนึ่งแถวต่อเที่ยวที่มีสถานะยกเลิก ชื่อผู้ยกเลิกมาจากเหตุการณ์ ผู้ดูแล ขอบเขต และชื่อเหตุผลเป็นข้อมูลปัจจุบัน ยอดรับไม่ใช่ยอดเงินสดสุทธิหลังคืนเงิน',
  'cancelledServices.dateBasis': 'เหตุการณ์ยกเลิกล่าสุด ทุกเวลารวมเที่ยวที่ไม่ทราบวัน',
  'cancelledServices.empty': 'ไม่มีหลักฐานหรือไม่เกี่ยวข้อง ศูนย์เป็นค่าตัวเลขที่ตรวจพบ',
  'cancelledServices.source.actorSnapshot': 'ชื่อผู้กระทำที่บันทึก ณ เหตุการณ์ยกเลิกที่เลือก รูปเป็นข้อมูลปัจจุบันตามประเภทและรหัส',
  'cancelledServices.source.reason': 'ชื่อตารางเหตุผลปัจจุบัน ไม่ใช่ชื่อในอดีต',
  'cancelledServices.source.event':
    'เหตุการณ์ TRIP CANCELLED ล่าสุดตามเวลาและรหัส อ่านเฉพาะข้อความเมตาที่รองรับ ไม่เดาเวลาจากข้อมูลอื่น',
  'cancelledServices.source.finance':
    'ค่าโดยสารและการชำระ BASE/OVERAGE ที่บันทึก ยอดเรียกเก็บและค้างรวมของเที่ยวยกเลิกเป็นศูนย์ คงยอดรับ ไม่คำนวณราคาใหม่',
  'cancelledServices.source.currentScope': 'พื้นที่ที่ผูกกับกลุ่มบริการปัจจุบัน ไม่ใช่ขอบเขตในอดีต',
  'cancelledServices.source.currentTrip':
    'ข้อมูลเที่ยวและการจองที่บันทึก พร้อมข้อมูลผู้โดยสาร ผู้ดูแล รถ และชื่อข้อมูลหลักปัจจุบัน โค้ดผู้ดูแลว่างเมื่อไม่มีโค้ดที่บันทึก',
  'cancelledServices.column.provider_id': 'รหัสผู้ให้บริการ',
  'cancelledServices.column.provider_name': 'ผู้ให้บริการ',
  'cancelledServices.column.trip_id': 'รหัสเที่ยว',
  'cancelledServices.column.trip_ref': 'เลขเที่ยว',
  'cancelledServices.column.booking_id': 'รหัสการจอง',
  'cancelledServices.column.trip_status': 'สถานะเที่ยว',
  'cancelledServices.column.trip_leg': 'ขาเดินทาง',
  'cancelledServices.column.service_mode': 'รูปแบบบริการ',
  'cancelledServices.column.dispatch_mode': 'รูปแบบจัดสรร',
  'cancelledServices.column.created_at': 'เวลาสร้าง',
  'cancelledServices.column.service_date': 'วันบริการ',
  'cancelledServices.column.service_date_basis': 'ที่มาวันบริการ',
  'cancelledServices.column.scheduled_start': 'เวลาเริ่มตามนัด',
  'cancelledServices.column.scheduled_end': 'เวลาจบตามนัด',
  'cancelledServices.column.pickup_appt_at': 'เวลานัดรับ',
  'cancelledServices.column.arrive_by_at': 'เวลาถึงปลายทาง',
  'cancelledServices.column.cancel_event_id': 'รหัสเหตุการณ์ยกเลิก',
  'cancelledServices.column.cancelled_at': 'เวลายกเลิก',
  'cancelledServices.column.date_basis': 'ที่มาวันยกเลิก',
  'cancelledServices.column.cancel_actor_type': 'ประเภทผู้ยกเลิก',
  'cancelledServices.column.cancel_actor_id': 'รหัสผู้ยกเลิก',
  'cancelledServices.column.cancel_actor_name': 'ชื่อผู้ยกเลิก ณ เหตุการณ์',
  'cancelledServices.column.cancel_reason_id': 'รหัสเหตุผล',
  'cancelledServices.column.cancel_reason_code': 'โค้ดเหตุผล',
  'cancelledServices.column.cancel_reason_label': 'เหตุผลปัจจุบัน',
  'cancelledServices.column.cancel_reason_label_source': 'ที่มาชื่อเหตุผล',
  'cancelledServices.column.cancel_note': 'หมายเหตุยกเลิก',
  'cancelledServices.column.passenger_reason': 'เหตุผลผู้โดยสาร',
  'cancelledServices.column.passenger_id': 'รหัสผู้โดยสาร',
  'cancelledServices.column.passenger_code': 'โค้ดผู้โดยสาร',
  'cancelledServices.column.passenger_name': 'ชื่อผู้โดยสารปัจจุบัน',
  'cancelledServices.column.passenger_phone': 'โทรศัพท์ผู้โดยสาร',
  'cancelledServices.column.agent_id': 'รหัสผู้ดูแลที่จัดสรร',
  'cancelledServices.column.agent_code': 'โค้ดผู้ดูแล',
  'cancelledServices.column.agent_name': 'ชื่อผู้ดูแลปัจจุบัน',
  'cancelledServices.column.agent_phone': 'โทรศัพท์ผู้ดูแล',
  'cancelledServices.column.vehicle_id': 'รหัสรถ',
  'cancelledServices.column.vehicle_plate': 'ทะเบียนรถ',
  'cancelledServices.column.service_area_ids': 'รหัสพื้นที่บริการปัจจุบัน',
  'cancelledServices.column.service_area_names': 'พื้นที่บริการปัจจุบัน',
  'cancelledServices.column.service_group_id': 'รหัสกลุ่มบริการ',
  'cancelledServices.column.service_group_name': 'กลุ่มบริการ',
  'cancelledServices.column.scope_provenance': 'ที่มาขอบเขตบริการ',
  'cancelledServices.column.origin_label': 'ต้นทาง',
  'cancelledServices.column.destination_label': 'ปลายทาง',
  'cancelledServices.column.currency': 'สกุลเงิน',
  'cancelledServices.column.fare_state': 'สถานะค่าโดยสาร',
  'cancelledServices.column.quote_provenance': 'ที่มาราคาเสนอ',
  'cancelledServices.column.quoted_total': 'ยอดราคาเสนอ',
  'cancelledServices.column.current_total': 'ค่าโดยสารที่บันทึก',
  'cancelledServices.column.final_total': 'ยอดสุดท้าย',
  'cancelledServices.column.fare_adjustment_delta': 'ส่วนต่างราคา',
  'cancelledServices.column.fare_base': 'ค่าโดยสารพื้นฐาน',
  'cancelledServices.column.fare_overage_distance': 'ค่าโดยสารระยะเกิน',
  'cancelledServices.column.fare_overage_time': 'ค่าโดยสารเวลาเกิน',
  'cancelledServices.column.fare_surcharge_total': 'ค่าบริการเพิ่ม',
  'cancelledServices.column.fare_computed_at': 'เวลาคำนวณค่าโดยสาร',
  'cancelledServices.column.billing_distance_source': 'ที่มาระยะคิดเงิน',
  'cancelledServices.column.billing_duration_source': 'ที่มาเวลาคิดเงิน',
  'cancelledServices.column.billable_distance_km': 'ระยะคิดเงิน (กม.)',
  'cancelledServices.column.billable_duration_min': 'เวลาคิดเงิน (นาที)',
  'cancelledServices.column.fare_is_free': 'สิทธิฟรี',
  'cancelledServices.column.base_payment_status': 'สถานะชำระพื้นฐาน',
  'cancelledServices.column.base_amount_due': 'ยอดเรียกเก็บพื้นฐาน',
  'cancelledServices.column.base_amount_received': 'ยอดรับพื้นฐาน',
  'cancelledServices.column.base_outstanding': 'ยอดค้างพื้นฐาน',
  'cancelledServices.column.base_due_by': 'กำหนดชำระพื้นฐาน',
  'cancelledServices.column.base_verified_at': 'เวลาตรวจสอบพื้นฐาน',
  'cancelledServices.column.overage_payment_status': 'สถานะชำระส่วนเกิน',
  'cancelledServices.column.overage_amount_due': 'ยอดเรียกเก็บส่วนเกิน',
  'cancelledServices.column.overage_amount_received': 'ยอดรับส่วนเกิน',
  'cancelledServices.column.overage_outstanding': 'ยอดค้างส่วนเกิน',
  'cancelledServices.column.overage_due_by': 'กำหนดชำระส่วนเกิน',
  'cancelledServices.column.overage_verified_at': 'เวลาตรวจสอบส่วนเกิน',
  'cancelledServices.column.billed_total': 'ยอดเรียกเก็บรวม',
  'cancelledServices.column.received_total': 'ยอดรับรวม',
  'cancelledServices.column.outstanding_total': 'ยอดค้างรวม',
  'cancelledServices.column.payment_state': 'สถานะการเงิน',
  'cancelledServices.column.requires_finance_review': 'ต้องตรวจสอบการเงิน',
  'cancelledServices.summary.cancelledTripCount': 'เที่ยวที่ยกเลิก',
  'cancelledServices.summary.fareTotalSum': 'ค่าโดยสารที่บันทึกรวม',
  'cancelledServices.summary.billedTotalSum': 'ยอดเรียกเก็บรวม',
  'cancelledServices.summary.receivedTotalSum': 'ยอดรับรวม',
  'cancelledServices.summary.outstandingTotalSum': 'ยอดค้างรวม',
  'cancelledServices.summary.freeTripCount': 'เที่ยวสถานะฟรี',
  'cancelledServices.summary.financeReviewCount': 'เที่ยวต้องตรวจสอบการเงิน',
  'cancelledServices.summary.missingFareCount': 'เที่ยวขาดค่าโดยสาร',
  'cancelledServices.coverage.missingEventCount':
    'การยกเลิกที่ตรงกับตัวกรองอื่นแต่ไม่มีเวลาเหตุการณ์ (ไม่รวมในช่วงวันที่จำกัด)',
  'cancelledServices.summary.passengerActorCount': 'ผู้โดยสารยกเลิก',
  'cancelledServices.summary.agentActorCount': 'ผู้ดูแลยกเลิก',
  'cancelledServices.summary.orgUserActorCount': 'เจ้าหน้าที่ยกเลิก',
  'cancelledServices.summary.partnerActorCount': 'คู่ค้ายกเลิก',
  'cancelledServices.summary.systemActorCount': 'ระบบยกเลิก',
  'cancelledServices.summary.unknownActorCount': 'ไม่ทราบผู้ยกเลิก',
  'cancelledServices.filter.actorType': 'ประเภทผู้ยกเลิก',
  'cancelledServices.filter.reasonId': 'รหัสเหตุผล',
  'cancelledServices.filter.reasonCode': 'โค้ดเหตุผล',
  'cancelledServices.filter.paymentState': 'สถานะการเงิน',
  'cancelledServices.filter.requiresFinanceReview': 'ต้องตรวจสอบการเงิน',
  'cancelledServices.filter.hasEvent': 'มีเหตุการณ์ยกเลิก',
  'cancelledServices.filter.serviceMode': 'รูปแบบบริการ',
  'cancelledServices.filter.passengerId': 'รหัสผู้โดยสาร',
  'cancelledServices.filter.agentId': 'รหัสผู้ดูแลที่จัดสรร',
  'cancelledServices.option.actorType.PASSENGER': 'ผู้โดยสาร',
  'cancelledServices.option.actorType.AGENT': 'ผู้ดูแล',
  'cancelledServices.option.actorType.ORG_USER': 'เจ้าหน้าที่',
  'cancelledServices.option.actorType.PARTNER': 'คู่ค้า',
  'cancelledServices.option.actorType.SYSTEM': 'ระบบ',
  'cancelledServices.option.actorType.UNKNOWN': 'ไม่ทราบ',
  'cancelledServices.option.paymentState.FREE': 'ฟรี',
  'cancelledServices.option.paymentState.FINANCE_REVIEW': 'ตรวจสอบการเงิน',
  'cancelledServices.option.paymentState.NOT_BILLABLE': 'ไม่เรียกเก็บ',
  'cancelledServices.option.paymentState.UNBILLED': 'ยังไม่เรียกเก็บ',
  'cancelledServices.option.paymentState.OUTSTANDING': 'ค้างชำระ',
  'cancelledServices.option.paymentState.PARTIAL': 'ชำระบางส่วน',
  'cancelledServices.option.paymentState.SETTLED': 'ชำระครบ',
  'cancelledServices.option.serviceMode.RIDE_AND_CARE': 'เดินทางพร้อมดูแล',
  'cancelledServices.option.serviceMode.CARE': 'ดูแล',
  'cancelledServices.option.serviceMode.RIDE': 'เดินทาง',
  'cancelledServices.option.serviceMode.TRAVEL': 'ท่องเที่ยว',
};
export const cancelledServicesTranslations = { th, en };
